define(function (require) {
	const tpl = require('./templates/t_cpv_elements_list.hbs');

	const currency_field = require('./elements/v_itv_currency_field');
	const date_time_field = require('./elements/v_itv_date_time_field');
	const decimal_field = require('./elements/v_itv_decimal_field');
	const dropdown_field = require('./elements/v_itv_dropdown_field');
	const number_field = require('./elements/v_itv_number_field');
	const text_field = require('./elements/v_itv_text_field');
	const checkbox_field = require('./elements/v_itv_checkbox_field');
	const radio_button_field = require('./elements/v_itv_radio_button_field');
	const map_field = require('./elements/v_itv_map_field');
	const grid = require('./grid/v_lov_detail_grid');
	const label = require('./elements/v_itv_label');

	const IpsModel = require('civicsBase/ipsModel');

	return Marionette.CompositeView.extend({
		childViewContainer: '.fields-region.blank',
		fieldType: '',
		template: tpl,
		metadata: [{
			tag: '__html__',
			attribute: 'isHtml'
		},
		{
			tag: '__fullwidthfield__',
			attribute: 'fullWidthField'
		},
		// {
		// 	tag: '__leftcolumnonly__',
		// 	attribute: 'leftColumnOnly'
		// },
		// {
		// 	tag: '__rightcolumnonly__',
		// 	attribute: 'rightColumnOnly'
		// },
		{
			tag: '__horizontalalign__',
			attribute: 'horizontalAlign'
		}],
		initialize: function (options) {
			if (options.config) {
				this.config = options.config;
			}
			this.values = options.values;
			this.processMetadata();
		},
		childViewOptions: function (model, index) {
			var ret = {
				config: this.config
			};
			ret.elementsListView = this.constructor;

			if (this.isPanel(model)) {
				//we have to rebuild the input to *this* collection view. Panels reuse THIS collection view.
				//typically, a collection view's children would only get a model automatically assigned. since
				//the child is actually a collection view itself, we are assigning the collection manuall.
				ret.collection = model.get('elements');
				ret.values = this.values;
			} else if (this.isGrid(model)) {
				ret.values = this.values;
				ret.moniker = model.get('moniker');
			}
			if (this.values) {
				var name = model.get('bind');
				if (this.values instanceof IpsModel && this.values.get(name) != undefined) {
					//ret.config.value = this.values.get(name);
					model.set('value', this.values.get(name));
				}
			}
			return ret;
		},
		processMetadata: function () {
			//if we have an empty tab, this.collection will be null. this should not really happen except when building a ruleset for CPQ.
			if (this.collection) {
				//iterate through each model in the collection, and check for metadata tags.
				this.collection.each((model) => {
					this.metadata.forEach((meta) => {//the metadata tags are defined on the view above.
						let text = model.get('text');
						if (text != null && text.toLowerCase().indexOf(meta.tag) != -1) {
							let regEx = new RegExp(meta.tag, 'gi');
							text = text.replace(regEx, '');
							let update = {};
							update[meta.attribute] = true;
							update.text = text;
							if (meta.attribute == 'isHtml' && model.get('type').toLowerCase() != 'radiobutton') {
								update.type = 'label';
							}else if(meta.attribute == 'fullWidthField'){
								let fieldContainerClass = model.get('fieldContainerClass') || '';
								fieldContainerClass += ' full-width';
								update.fieldContainerClass = fieldContainerClass.trim();
							}
							model.set(update, { silent: true });
						}
					});
				});
			}
		},

		getChildView(child) {
			if (!_.isEmpty(child.get('type'))) {
				var fieldType = this.getFieldType(child);
				switch (fieldType) {
					case 'decimal':
						return decimal_field;
					case 'currency':
						return currency_field;
					case 'number':
						return number_field;
					case 'date_time':
						return date_time_field;
					case 'dropdown':
						return dropdown_field;
					case 'textbox':
						return text_field;
					case 'checkbox':
						return checkbox_field;
					case 'radio_button':
						return radio_button_field;
					case 'label':
						return label;
					case 'grid':
						return grid;
					case 'mapfield':							
						return map_field;
					case 'panel':
						//panels reuse *THIS* constructor.
						return this.constructor;
					default:
				}
			}
			return null;
		},
		templateHelpers: function () {
			return {
				showFieldSet: (this.model &&
					this.model.get('type') &&
					this.model.get('type').toLowerCase() == 'panel' &&
					this.model.get('text') != null &&
					this.model.get('hasHeader') == true) ? true : false
			}
		},
		//end Marionette Functions
		getData: function () {
			var data = {};
			this.children.each(function (childView) {
				if (childView.getData != null) {
					var childData = childView.getData();
					if (childData != null) {
						data = $.extend(true, {}, data, childData);
					}
				}
			});
			return $.isEmptyObject(data) ? null : data;
		},
		getDeletedRows: function () {
			var data = [];
			this.children.each(function (childView) {
				if (childView.getDeletedRows != null) {
					var childData = childView.getDeletedRows();
					if (childData != null) {
						data = data.concat(childData);
					}
				}
			});
			return data;
		},
		getFieldType(child) {
			var type = child.get('type').toLowerCase();
			var fieldType = '';
			if (type == 'textbox') {
				fieldType = 'textbox';
				var dataType = child.get('dataType');
				if (!_.isEmpty(dataType)) {
					dataType = dataType.toLowerCase();
					switch (dataType) {
						case 'system.decimal':
							if (child.get('format') && child.get('format').toLowerCase() == 'currency') {
								fieldType = 'currency'
							} else {
								fieldType = 'decimal'
							}
							break;
						case 'system.single':
							fieldType = 'decimal';
							break;
						case 'system.int16':
						case 'system.int32':
						case 'system.int64':
							fieldType = 'number';
							break;
						case 'system.datetime':
							fieldType = 'date_time';
							break;
						case 'dropdown':
							fieldType = 'dropdown';
							break;
						case 'system.string':
							var moniker = child.get('moniker');
							if (!_.isEmpty(moniker)) {
								fieldType = 'dropdown';
							} else {
								fieldType = 'textbox';
							}
							break;
						default:
							fieldType = 'textbox';
					}
				}
			} else if (type == 'checkbox') {
				fieldType = 'checkbox';
			} else if (type == 'radiobutton') {
				fieldType = 'radio_button';
			} else if (type == 'dropdownbox') {
				fieldType = 'dropdown';
			} else if (type == 'label') {
				fieldType = 'label';
			} else if (type == 'panel' || type == 'tab' || type == 'tabpage') {
				fieldType = 'panel';
			} else if (type == 'table') {
				fieldType = 'grid';
			} else if (type == 'map') {
				fieldType = 'mapfield';
			}
			return fieldType;
		},
		isPanel: function (model) {
			return this.getFieldType(model) == 'panel';
		},
		isGrid: function (model) {
			return model.get('type') && model.get('type').toLowerCase() == 'table';
		},
	});
});